module.exports = __webpack_public_path__ + "static/media/single-sensor.7a799687.svg";